import { defineField, defineType } from "sanity";

export const aboutPage = defineType({
  name: "aboutPage",
  title: "About Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "testimonials", title: "Testimonials" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "aboutHeader",
      title: "About header",
      type: "string",
      description: "Main heading for the About page.",
      group: "content"
    }),
    defineField({
      name: "aboutBody",
      title: "About body",
      type: "array",
      description: "Main paragraph copy for the About page.",
      of: [
        {
          type: "block",
          styles: [
            { title: "Normal", value: "normal" },
            { title: "Highlight", value: "callout" },
            { title: "Closing", value: "question" }
          ],
          lists: [],
          marks: {
            decorators: [{ title: "Bold", value: "strong" }]
          }
        }
      ],
      group: "content"
    }),
    defineField({
      name: "aboutImage",
      title: "About image",
      type: "image",
      description: "Hero image for the About page.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers.",
          validation: (Rule) =>
            Rule.custom((value) => (value ? true : "Add alt text so the image is accessible.")).warning(
              "Add alt text so the image is accessible."
            )
        })
      ],
      group: "content"
    }),
    defineField({
      name: "testimonialsLabel",
      title: "Testimonials label",
      type: "string",
      description: "Small label above the testimonials heading (e.g. 'Love Letters From').",
      group: "testimonials"
    }),
    defineField({
      name: "testimonialsHeading",
      title: "Testimonials heading",
      type: "string",
      description: "Heading for the testimonials section (e.g. 'Our Clients:').",
      group: "testimonials"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines (e.g. 'About Us | Vault 88').",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "About Page"
    })
  }
});
